import React, { useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";

import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import {
  ROUTES,
  messages,
  customerConstants,
} from "../../../../../../constants";
import ReviewYourSb from "./Tabs/ReviewYourSb";
import MessageBoard from "./Tabs/MessageBoard";
import ExtendYourSb from "./Tabs/ExtendYourSb";
import RecapFeedback from "./Tabs/RecapFeedback";
import AccessGallery from "./Tabs/AccessGallery";
import TipYouSb from "./Tabs/TipYourSb/TipYourSb";
import DownloadInvoice from "./Tabs/DownloadInvoice";
import { NavigateToPath } from "../../../../../../system";
// import useGetQueryParams from "../../../../../../shared/components/CustomHooks/GetQueryParams";
// A custom hook that builds on useLocation to parse
// the query string for you.

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

const MyEventsDashboard = () => {
  // let query = useGetQueryParams();
  const history = useHistory();
  const location = useLocation();
  const [value, setValue] = useState(
    customerConstants.EXTEND_YOUR_SHUTTERB_TAB_NUMBER
  );
  const { tab } = useParams();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const updateTabInParams = (tab) => {
    let newLocation =
      location.pathname.slice(0, location.pathname.lastIndexOf("/") + 1) + tab;
    return newLocation;
  };
  //   Tabs MUI Functionality Ends

  React.useEffect(() => {
    setValue(
      Number(
        tab === customerConstants.EXTEND_YOUR_SHUTTERB
          ? customerConstants.EXTEND_YOUR_SHUTTERB_TAB_NUMBER
          : tab === customerConstants.TIP_YOUR_SHUTTERB
          ? customerConstants.TIP_YOUR_SHUTTERB_TAB_NUMBER
          : tab === customerConstants.ACCESS_GALLERY
          ? customerConstants.ACCESS_GALLERY_TAB_NUMBER
          : tab === customerConstants.DOWNLOAD_INVOICE
          ? customerConstants.DOWNLOAD_INVOICE_TAB_NUMBER
          : tab === customerConstants.REVIEW_YOUR_SHUTTERB
          ? customerConstants.REVIEW_YOUR_SHUTTERB_TAB_NUMBER
          : tab === customerConstants.RECAP_FEEDBACK
          ? customerConstants.RECAP_FEEDBACK_TAB_NUMBER
          : tab === customerConstants.MESSAGE_BOARD
          ? customerConstants.MESSAGE_BOARD_TAB_NUMBER
          : customerConstants.EXTEND_YOUR_SHUTTERB_TAB_NUMBER // default
      )
    );
  }, [tab]);
  return (
    <div className="container-fluid">
      <Box className="row my-5 px-2 px-md-3 customer-dashboard-con customer-event-dashboard ">
        <Box className="col-12 col-lg-3 col-xl-2  bordered-side-bar mx-lg-0 mx-auto">
          <h5 className="ed-sidebar-heading text px-2 text-lg-left text-center">
            my events
          </h5>
          <Tabs
            value={value}
            onChange={handleChange}
            orientation="vertical"
            aria-label="basic event tabs"
            sx={{
              "& .MuiTabs-flexContainer": {
                alignItems: "center",
              },
              "& .MuiTab-root": {
                minHeight: 32,
                padding: "10px 10px",
                margin: "10px 0",

                textAlign: {
                  sm: "center",
                  lg: "start",
                  xs: "center",
                },
                width: "100%",
              },
            }}
          >
            <Tab
              className="customer-dashboard-tab-btn m-auto m-md-0 align-items-center align-items-lg-start mw-160 text"
              label="EXTEND YOUR SHUTTERB"
              onClick={() => {
                NavigateToPath(
                  history,
                  updateTabInParams(customerConstants.EXTEND_YOUR_SHUTTERB)
                );
              }}
              {...a11yProps(customerConstants.EXTEND_YOUR_SHUTTERB_TAB_NUMBER)}
            />
            <Tab
              className="customer-dashboard-tab-btn m-auto m-md-0 align-items-center align-items-lg-start mw-160 text"
              label="TIP YOUR SHUTTERB"
              onClick={() => {
                NavigateToPath(
                  history,
                  updateTabInParams(customerConstants.TIP_YOUR_SHUTTERB)
                );
              }}
              {...a11yProps(customerConstants.TIP_YOUR_SHUTTERB_TAB_NUMBER)}
            />
            <Tab
              className="customer-dashboard-tab-btn m-auto m-md-0 align-items-center align-items-lg-start mw-160 text"
              label="ACCESS GALLERY"
              onClick={() => {
                NavigateToPath(
                  history,
                  updateTabInParams(customerConstants.ACCESS_GALLERY)
                );
              }}
              {...a11yProps(customerConstants.ACCESS_GALLERY_TAB_NUMBER)}
            />
            <Tab
              className="customer-dashboard-tab-btn m-auto m-md-0 align-items-center align-items-lg-start mw-160 text"
              label="DOWNLOAD INVOICE"
              onClick={() => {
                NavigateToPath(
                  history,
                  updateTabInParams(customerConstants.DOWNLOAD_INVOICE)
                );
              }}
              {...a11yProps(customerConstants.DOWNLOAD_INVOICE_TAB_NUMBER)}
            />
            <Tab
              className="customer-dashboard-tab-btn m-auto m-md-0 align-items-center align-items-lg-start mw-160 text"
              label="REVIEW YOUR SHUTTERB"
              onClick={() => {
                NavigateToPath(
                  history,
                  updateTabInParams(customerConstants.REVIEW_YOUR_SHUTTERB)
                );
              }}
              {...a11yProps(customerConstants.REVIEW_YOUR_SHUTTERB_TAB_NUMBER)}
            />
            <Tab
              className="customer-dashboard-tab-btn m-auto m-md-0 align-items-center align-items-lg-start mw-160 text"
              label="Recap Feedback"
              onClick={() => {
                NavigateToPath(
                  history,
                  updateTabInParams(customerConstants.RECAP_FEEDBACK)
                );
              }}
              {...a11yProps(customerConstants.RECAP_FEEDBACK_TAB_NUMBER)}
            />
            <Tab
              className="customer-dashboard-tab-btn m-auto m-md-0 align-items-center align-items-lg-start mw-160 text"
              label="MESSAGE BOARD"
              onClick={() => {
                NavigateToPath(
                  history,
                  updateTabInParams(customerConstants.MESSAGE_BOARD)
                );
              }}
              {...a11yProps(customerConstants.MESSAGE_BOARD_TAB_NUMBER)}
            />
            <Tab
              className="customer-dashboard-tab-btn m-auto m-md-0 align-items-center align-items-lg-start mw-160 text"
              label={messages.BACK_TO_MY_EVENTS}
              onClick={() => {
                NavigateToPath(history, `${ROUTES.MY_EVENTS_TAB}`);
              }}
            />
          </Tabs>
        </Box>
        <Box className="col-12 col-md-12 col-lg-9 col-xl-10 py-0 tab-pannel pt-5 pt-lg-0 custom-min-height">
          <TabPanel value={value} index={0} className="position-relative pt-3">
            <ExtendYourSb />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <TipYouSb />
          </TabPanel>
          <TabPanel value={value} index={2} className="">
            <AccessGallery />
          </TabPanel>
          <TabPanel value={value} index={3}>
            <DownloadInvoice />
          </TabPanel>
          <TabPanel value={value} index={4}>
            <ReviewYourSb />
          </TabPanel>
          <TabPanel value={value} index={5}>
            <RecapFeedback />
          </TabPanel>
          <TabPanel value={value} index={6}>
            <MessageBoard />
          </TabPanel>
        </Box>
      </Box>
    </div>
  );
};

export default MyEventsDashboard;
